const TopCards = ({tabla_totales}) => {
   return (
      <div className="row">
         <div className="col-lg-3 col-6">
            <div className="small-box bg-primary">
               <div className="inner">
                  <h3>{tabla_totales[1]}</h3>
                  <p>Buenos</p>
               </div>
               <div className="icon">
                  <i className="fas fa-check-circle"></i>
               </div>

            </div>
         </div>
         <div className="col-lg-3 col-6">
            <div className="small-box bg-success">
               <div className="inner">
                  <h3>{tabla_totales[2]}</h3>
                  <p>Regulares</p>
               </div>
               <div className="icon">
                  <i className="fas fa-cogs"></i>
               </div>

            </div>
         </div>
         <div className="col-lg-3 col-6">
            <div className="small-box bg-warning">
               <div className="inner">
                  <h3>{tabla_totales[3] + tabla_totales[4]}</h3>
                  <p>Malos</p>
               </div>
               <div className="icon">
                  <i className="fas fa-briefcase-medical"></i>
               </div>

            </div>
         </div>
         <div className="col-lg-3 col-6">
            <div className="small-box bg-danger">
               <div className="inner">
                  <h3>{tabla_totales[5] + tabla_totales[6]}</h3>
                  <p>Inoperativos</p>
               </div>
               <div className="icon">
                  <i className="fas fa-exclamation-triangle"></i>
               </div>

            </div>
         </div>
      </div>
   )

}

export default TopCards